import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import React from 'react';

export const ExcludedSituationModal = React.memo(
  ({
    isOpen,
    onClose,
    feedback,
    onFeedbackChange,
    onSubmit,
    onGoBack,
    t,
  }: {
    isOpen: boolean;
    onClose: () => void;
    feedback: string;
    onFeedbackChange: (value: string) => void;
    onSubmit: () => void;
    onGoBack: () => void;
    t: any;
  }) => {
    if (!isOpen) return null;

    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4'
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          transition={{ type: 'spring', duration: 0.3 }}
          className='relative w-full max-w-lg rounded-lg bg-white p-6 shadow-xl'
          onClick={(e) => e.stopPropagation()}
        >
          <div className='mb-4'>
            <h2 className='mb-2 text-lg font-semibold'>
              {t('formQuestionnaire.messages.excludedSituation.title')}
            </h2>
            <p className='mb-2 text-sm text-gray-600'>
              {t('formQuestionnaire.messages.excludedSituation.description1')}
            </p>
            <p className='text-sm text-gray-600'>
              {t('formQuestionnaire.messages.excludedSituation.description2')}
            </p>
            <p className='text-sm text-gray-600'>
              {t('formQuestionnaire.messages.excludedSituation.description2')}
            </p>
            <p className='text-sm text-gray-600'>
              {t('formQuestionnaire.messages.excludedSituation.description2')}
            </p>
            <p className='text-sm text-gray-600'>
              {t('formQuestionnaire.messages.excludedSituation.description2')}
            </p>
          </div>

          <textarea
            value={feedback}
            onChange={(e) => onFeedbackChange(e.target.value)}
            placeholder={t(
              'formQuestionnaire.messages.excludedSituation.placeholder'
            )}
            className='mb-4 h-32 w-full resize-none rounded-md border border-gray-300 p-2 text-sm focus:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500'
          />

          <p className='mb-4 text-sm text-red-600'>
            {t('formQuestionnaire.messages.excludedSituation.cannotProceed')}
          </p>

          <div className='flex justify-end space-x-2'>
            <button
              onClick={onGoBack}
              className='rounded-md bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2'
            >
              {t('formQuestionnaire.messages.excludedSituation.askAnother')}
            </button>
            <button
              onClick={onSubmit}
              disabled={!feedback.trim()}
              className={cn(
                'rounded-md bg-purple-600 px-4 py-2 text-sm font-medium text-white hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2',
                !feedback.trim() && 'cursor-not-allowed opacity-50'
              )}
            >
              {t('formQuestionnaire.buttons.submit')}
            </button>
          </div>
        </motion.div>
      </motion.div>
    );
  }
);

ExcludedSituationModal.displayName = 'ExcludedSituationModal';
